<template>
  <div>
    <span v-if="config && config.loading">
      <div v-loading.fullscreen.lock="config.loading.save" element-loading-text="Processando..."></div>
    </span>

    <el-form label-position="top" label-width="150px" :model="data" :ref="id">
      <div class="row">
        <!--FORM ITENS-->
        <div :class="item.class" v-for="(item, i) in itens" :key="i" v-if="!config || !config.hidden || !config.hidden[item.field]" :style="item.style">
          <div class="col-12 item-group" v-if="item.type == 'group'">
            <i :class="item.icon" />
            {{ item.label }}
          </div>

          <!-- INPUTS -->
          <el-form-item v-else-if="item.type != 'group'" :label="item.label" :title="item.placeholder" :class="error && error[item.field] ? 'is-error' : ''" :rules="handleRules(item.rules)">
            <!-- INPUT LABEL -->
            <span slot="label" style="color: #636363" v-if="item.label">
              <span>
                <label v-if="config.label && config.label[item.field]">{{config.label[item.field]}}</label>
                <label v-else>{{item.label}}</label>
                <!-- <el-tooltip
                      v-if="item.info"
                      class="item"
                      effect="dark"
                      :content="item.info"
                      placement="top"
                    >
                      <a href="#">
                        <i class="fa fa-question-circle" aria-hidden="true"></i>
                      </a>
                    </el-tooltip> -->

                <a href="#" v-if="item.info" :title="item.info">
                  <i class="fa fa-question-circle" aria-hidden="true"></i>
                </a>

                <el-switch v-if="item.title && item.title.model" v-model="data[item.title.model]" :title="config.description ? config.description[item.title.model] : ''" :active-value="1" :inactive-value="0" :active-text="config.title[item.title.model]" inactive-text=""> </el-switch>
                <ed-button type="text" v-if="item.title && item.title.link && config.click[item.title.link]" :icon="item.title.icon" :value="config.title[item.title.link]" @click="config.click[item.title.link]()" />
              </span>
            </span>

            <!--TEXT, PASSWORD, EMAIL, TEXTAREA-->
            <el-input
              v-if="item.type == 'text' || item.type == 'password' || item.type == 'textarea' || item.type == 'email' || item.type == 'number'"
              v-model="data[item.field]"
              v-mask="item.mask ? mask[item.mask] : ''"
              :type="item.type"
              :rows="item.rows ? item.rows : 2"
              :maxlength="item.maxlength ? item.maxlength : 5000"
              :clearable="item.clearable ? true : false"
              :readonly="config.readonly && config.readonly[item.field] ? true : false"
              :disabled="config.deleted_at || (config.disabled && config.disabled[item.field])"
              :prefix-icon="item.prefix ? item.prefix : ''"
              :placeholder="item.placeholder"
              :show-word-limit="item.maxlength ? true : false"
              autocomplete="false"
            />

            <!--NUMBER -->
            <el-input-number
              v-else-if="item.type == 'number'"
              v-model="data[item.field]"
              :min="item.min ? item.min : 0"
              :max="item.max ? item.max : 99999999999"
              :clearable="item.clearable ? true : false"
              :readonly="config.readonly && config.readonly[item.field] ? true : false"
              :disabled="config.deleted_at || (config.disabled && config.disabled[item.field])"
              :prefix-icon="item.prefix ? item.prefix : ''"
              :placeholder="item.placeholder"
            />

            <!--INPUT SELECT-->
            <el-input
              v-else-if="item.type == 'select-text' && config.list[item.select_field]"
              v-model="data[item.field]"
              v-mask="item.mask ? mask[item.mask] : ''"
              :type="item.type"
              :rows="item.rows ? item.rows : 2"
              :maxlength="item.maxlength ? item.maxlength : 5000"
              :clearable="item.clearable ? true : false"
              :readonly="config.readonly && config.readonly[item.field] ? true : false"
              :disabled="config.deleted_at || (config.disabled && config.disabled[item.field])"
              :prefix-icon="item.prefix ? item.prefix : ''"
              :placeholder="item.placeholder"
              :show-word-limit="item.maxlength ? true : false"
              autocomplete="false"
            >
              <el-select popper-append-to-body  slot="prepend" placeholder="---" v-model="data[item.select_field]" value-key="id" style="width: 100px">
                <el-option v-for="item in config.list[item.select_field]" v-bind:data="item" v-bind:key="item.id" :label="item.nome" :value="item.id"> </el-option>
              </el-select>
            </el-input>

            <!--CHECKBOX -->
            <el-checkbox class="disable-checkbox-label" v-else-if="item.type == 'checkbox'" v-model="data[item.field]" :disabled="config.deleted_at || (config.disabled && config.disabled[item.field])" label="1" true-label="1" false-label="0" />

            <!--COLOR PICKER -->
            <el-color-picker v-else-if="item.type == 'color'" v-model="data[item.field]" :disabled="config.deleted_at || (config.disabled && config.disabled[item.field])" :predefine="predefineColors" color-format="hex" />

            <!--BOOLEAN -->
            <el-switch v-else-if="item.type == 'boolean'" v-model="data[item.field]" :active-value="1" :inactive-value="0" :readonly="config.readonly && config.readonly[item.field] ? true : false" :disabled="config.deleted_at || (config.disabled && config.disabled[item.field])" />

            <!--DATE-->
            <el-date-picker
              v-else-if="item.type == 'date'"
              v-model="data[item.field]"
              v-mask="mask.date"
              type="date"
              placeholder="dd/mm/aaaa"
              value-format="dd/MM/yyyy"
              format="dd/MM/yyyy"
              :picker-options="handleDateOptions(item)"
              :clearable="item.clearable ? true : false"
              :disabled="config.deleted_at || (config.disabled && config.disabled[item.field])"
              :readonly="config.readonly && config.readonly[item.field] ? true : false"
            />

            <!--TIME-->
            <el-time-select v-else-if="item.type == 'time'" v-model="data[item.field]" :picker-options="handleTimeOptions(item)" :clearable="item.clearable ? true : false" :disabled="config.deleted_at || (config.disabled && config.disabled[item.field])" />

            <!--DATE RANGE-->
            <el-date-picker
              v-else-if="item.type == 'date-range'"
              v-model="data[item.field]"
              type="daterange"
              placeholder="dd/mm/aaaa"
              value-format="dd/MM/yyyy"
              format="dd/MM/yyyy"
              :clearable="item.clearable ? true : false"
              start-placeholder="Data Inicial"
              end-placeholder="Data Final"
              :disabled="config.deleted_at || (config.disabled && config.disabled[item.field])"
            />

            <!--TIME RANGE-->
            <el-time-picker v-else-if="item.type == 'time-range'" v-model="data[item.field]" is-range value-format="HH:mm" format="HH:mm" start-placeholder="Início" end-placeholder="Fim" />

            <!--UPLOAD-->
            <ed-upload v-else-if="item.type == 'upload'" :input="item.field" :currentFile="data[item.field]" :accept="item.accept ? item.accept : ''" :multiple="item.multiple ? true : false" :disabled="config.deleted_at || (config.disabled && config.disabled[item.field])" />

            <!--CEP-->
            <el-input
              v-else-if="item.type == 'cep'"
              v-model="data[item.field]"
              @blur="handleEndereco"
              :maxlength="item.maxlength ? item.maxlength : 10"
              :readonly="config.readonly && config.readonly[item.field] ? true : false"
              :disabled="config.deleted_at || (config.disabled && config.disabled[item.field])"
              v-mask="mask.cep"
            />

            <!--CNAE -->
            <el-select popper-append-to-body  v-else-if="item.type == 'select-cnae'" v-model="data[item.field]" placeholder="Selecione" :loading="loadingCnae" :disabled="config.deleted_at || (config.disabled && config.disabled[item.field])" filterable clearable remote :remote-method="handleCnaeDebounce" value-key="cnae">
              <el-option v-for="cnae in cnaes" :key="cnae.id" :label="cnae.cnae + ' | ' + cnae.nome" :value="cnae"> </el-option>
            </el-select>

            <!--ESTADO -->
            <el-select popper-append-to-body  v-else-if="item.type == 'select-uf'" v-model="data[item.field]" placeholder="Selecione" :loading="loadingEstado" :disabled="config.deleted_at || (config.disabled && config.disabled[item.field])" @change="handleCidadeDebounce" filterable clearable>
              <el-option v-for="estado in estados" :key="estado.uf" :label="estado.estado.toUpperCase()" :value="item.value_uf ? estado.uf : estado.uf"> </el-option>
            </el-select>

            <!--CIDADE -->
            <el-select popper-append-to-body  v-else-if="item.type == 'select-cidade'" v-model="data[item.field]" placeholder="Pesquisa..." :loading="loadingCidade" :disabled="config.deleted_at || (config.disabled && config.disabled[item.field])" filterable remote clearable :remote-method="handleCidadeDebounce">
              <el-option v-for="cidade in cidades" :key="cidade.id_cidade" :label="cidade.cidade.toUpperCase()" :value="cidade.id_cidade"> </el-option>
            </el-select>

            <!--CIDADE -->
            <ed-editor v-else-if="item.type == 'editor'" :conteudo="data[item.field]" :model="item.field" />

            <!--TIPO-->
            <el-select popper-append-to-body 
              v-else-if="item.type == 'select-tipo'"
              v-model="data[item.field]"
              :clearable="item.clearable ? true : false"
              :multiple="item.multiple ? true : false"
              :collapse-tags="true"
              :placeholder="item.placeholder ? item.placeholder : 'Selecione'"
              filterable
              :disabled="config.deleted_at || (config.disabled && config.disabled[item.field])"
              value-key="id"
            >
              <el-option v-for="tipo in tipos[item.tipo]" :key="tipo.id" :label="tipo.descricao" :value="item.valor ? toString(tipo[item.valor]) : parseInt(tipo.id)" :title="item.obs">
                <div>{{ tipo.descricao }}</div>
                <div style="color: #8492a6; font-size: 13px" v-if="tipo.obs">{{ tipo.obs }}</div>
              </el-option>
            </el-select>

            <!-- TIPO RADIO -->
            <el-radio-group v-else-if="item.type == 'select-tipo-radio'" v-model="data[item.field]">
              <el-radio v-for="tipo in tipos[item.tipo]" :key="tipo.id" :label="item.valor ? toString(tipo[item.valor]) : parseInt(tipo.id)" :disabled="config.deleted_at || (config.disabled && config.disabled[item.field] ? true : false)" style="padding: 5px">
                {{ tipo.descricao }}
              </el-radio>
            </el-radio-group>

            <!-- TIPO CHECKBOX -->
            <div v-else-if="item.type == 'select-tipo-checkbox'">
              <el-checkbox v-model="data[item.field]" v-for="tipo in tipos[item.tipo]" :key="tipo.id" :label="item.valor ? tipo[item.valor] : tipo.id" :disabled="config.deleted_at || (config.disabled && config.disabled[item.field] ? true : false)" style="padding: 5px; width: 100% !important">
                {{ tipo.descricao }}
              </el-checkbox>
            </div>

            <!--SELECT CUSTOM-->
            <el-select popper-append-to-body 
              v-else-if="item.type == 'select-custom' && config.click && config.click[item.field] && config.list && config.list[item.field]"
              v-model="data[item.field]"
              :clearable="item.clearable ? true : false"
              :loading="config.loading[item.field]"
              :placeholder="item.placeholder ? item.placeholder : 'Pesquisar...'"
              filterable
              :disabled="config.disabled && config.disabled[item.field] ? true : false"
              :multiple="item.multiple ? true : false"
              collapse-tags
              remote
              :remote-method="item.disable_remote ? null : config.click[item.field]"
              value-key="id"
            >
              <el-option v-for="(val, j) in config.list[item.field]" :key="j" :label="handleLabelSelect(item, val)" :value="handleValueSelect(item, val)" :title="handleTitleSelect(item, val)">
                <span v-html="handleLabelSelectHtml(item, val)" />
              </el-option>
            </el-select>

            <!--GHE-->
            <el-select popper-append-to-body 
              v-else-if="item.type == 'select-ghe' && config.click && config.click[item.field] && config.list && config.list[item.field]"
              v-model="data[item.field]"
              :clearable="item.clearable ? true : false"
              :loading="config.loading[item.field]"
              :disabled="config.deleted_at || (config.disabled && config.disabled[item.field])"
              placeholder="Selecione"
              filterable
            >
              <el-option-group
                v-for="revisao in config.list[item.field]"
                :key="revisao.id"
                :label="(revisao.parent ? revisao.parent.rev + ' (' + revisao.parent.descricao.toUpperCase() + ' em ' + toDate(revisao.parent.data_hora, true) + ') / ' : '') + revisao.rev + ' (' + revisao.descricao.toUpperCase() + ' em ' + toDate(revisao.data_hora, true) + ')'"
              >
                <el-option
                  v-for="ghe in revisao.options"
                  :key="revisao.id + ghe.id"
                  :label="ghe.id == '0' ? ghe.descricao : ghe.ghe + ' (' + ghe.descricao + ')'"
                  :value="ghe.id"
                  :disabled="ghe.id == '0' || revisao.disabled || (revisao.parent && revisao.parent.disabled) || (config.disabled && config.disabled[item.field]) ? true : false"
                  :title="revisao.disabled || (revisao.parent && revisao.parent.disabled) ? 'O PCMSO desde GHE está vencido. Entre em contato conosco para melhores esclarecimentos.' : ''"
                >
                </el-option>
              </el-option-group>
            </el-select>

            <!--REVISAO-->
            <el-select popper-append-to-body 
              v-else-if="item.type == 'select-revisao' && config.click && config.click[item.field] && config.list && config.list[item.field]"
              v-model="data[item.field]"
              :clearable="item.clearable ? true : false"
              :loading="config.loading[item.field]"
              :disabled="config.deleted_at || (config.disabled && config.disabled[item.field])"
              placeholder="Selecione"
              filterable
              @change="config.change[item.field](data[item.field])"
            >
              <el-option-group v-for="(revisao, j) in config.list[item.field]" :key="j" :label="revisao.label" value-key="id">
                <el-option v-for="(val, k) in revisao.options" :key="k" :label="handleLabelSelect(item, val)" :value="handleValueSelect(item, val)" :title="handleTitleSelect(item, val)">
                  <span v-html="handleLabelSelectHtml(item, val)" />
                </el-option>
              </el-option-group>
            </el-select>

            <!--LIMITE DE CRÉDITO-->
            <div v-else-if="item.type == 'limite-credito'">
              <el-radio v-model="data.ilimitada" :label="1">Ilimitada</el-radio>
              <el-radio v-model="data.ilimitada" :label="0">
                Com limite de
                <input :style="'width:200px !important;' + (data.ilimitada == 1 ? 'background:#ececec' : '')" class="el-input__inner" v-mask="'money'" placeholder="Informe o valor" prefix-icon="fa fa-usd" v-model="data.limite" :disabled="data.ilimitada == 1" />
              </el-radio>
            </div>

            <div v-if="error && error[item.field]" class="mt-1" style="color: #e66666; font-size: 9pt">
              {{ error[item.field][0] }}
            </div>
            <div v-if="config.obs && config.obs[item.field]" style="font-size: 9pt" v-html="config.obs[item.field]">
              
            </div>
          </el-form-item>
        </div>

        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <slot name="form-itens" />
        </div>

        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-center" style="margin-top: 15px">
          <slot name="form-footer" />
        </div>

        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-center" style="margin-top: 15px" v-if="config && config.click && config.click.save">
          <ed-button @click="handlerSave" :loading="config.loading.save" icon="fa fa-save" type="success" value=" Salvar" />
        </div>

        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-1" v-if="data.usuario && data.updated_at">
          <ed-alert type="success">
            <div slot="description"><b>Última Atualização:</b> {{ data.usuario.usuario }} em {{ toDate(data.updated_at) }}</div>
          </ed-alert>
        </div>

        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-2">
          <ed-error title="Atenção" type="error" :response="response" />
        </div>

        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-center">
          <slot name="form-end" />
        </div>
      </div>
    </el-form>
  </div>
</template>

<script>
import Rest from "common/rest";
import EdUpload from "common/upload";
import EdButton from "common/button";
import EdError from "common/error";
import EdAlert from "common/alert";
import EdEditor from "common/ckeditor";

export default {
  name: "ed-form",
  components: { EdButton, EdError, EdUpload, EdAlert, EdEditor },
  mixins: [Rest],
  props: {
    data: {
      type: Object,
      default: function () {
        return {};
      },
    },
    response: {
      type: Object,
      default: function () {
        return {};
      },
    },
    save: {
      type: Function,
      default: function () {
        return {};
      },
    },
    config: {
      type: Object,
      default: function () {
        return {};
      },
    },
    itens: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  watch: {
    data() {
      this.inicialize();
    },
    response() {
      this.inicialize();
    },
    save() {},
    config() {
      this.inicialize();
    },
    "config.click"() {
      this.inicialize();
    },
    "config.list"() {
      this.inicialize();
    },
    "config.tipo_exclude"() {
      this.inicialize();
    },
    "config.obs"() {
    },
    itens() {},
  },

  data() {
    return {
      id: this.toString(new Date().getTime()),
      rules: {
        required: { required: true, message: "Campo Obrigatório", trigger: "blur" },
        email: { type: "email", message: "Informe um email válido", trigger: ["blur", "change"] },
      },
      mask: {
        money: "money",
        number: "999999999999999999",
        cep: "99.999-999",
        cbo: "9999-99",
        time: "99:99:99",
        cpf: "999.999.999-99",
        cnpj: "99.999.999/9999-99",
        documento: "99.999.999/9999-99",
        celular: "(99)99999-9999",
        telefone: "(99) 9999-9999",
        date: "99/99/9999",
        esocial: "99.99.999",
      },
      predefineColors: ["#ff4500", "#d72d12", "#ff8c00", "#ffd700", "#90ee90", "#18BE31", "#00ced1", "#1e90ff", "#c71585", "#9C5317"],
      error: {},
      tipos: {},
      cidades: [],
      estados: [],
      funcoes: [],
      events: [],
      cnaes: [],
      revisoesEmp: [],
      status: 200,
      loadingEstado: false,
      loadingCidade: false,
      loadingCnae: false,
      handleCidadeDebounce: null,
      handleCnaeDebounce: null,
      maxDaysTomorrow: null,
    };
  },
  beforeDestroy() {
    this.handlerClear();
  },
  mounted() {
    this.inicialize();
    this.handleCidadeDebounce = _.debounce(this.handleCidade, 1000);
    this.handleCnaeDebounce = _.debounce(this.handleCnae, 1000);
  },

  methods: {
    inicialize() {
      this.error = {};

      if (this.response.options && this.response.options.data) {
        this.error = this.response.options.data;
      }
      this.status = this.response.status ? this.response.status : 200;

      if (this.config.estado) {
        this.handleEstado();
      }

      if (this.config.cnae) {
        this.handleCnae(this.data.cnae && this.data.cnae.cnae ? this.data.cnae.cnae : this.data.cnae);
      }

      if (this.config.tipo && this.config.tipo.length > 0) {
        this.handleParametros();
      }
    },

    handlerClear() {
      this.id = null;
      this.error = {};
      this.tipos = {};
      (this.cidades = []), (this.estados = []);
      this.funcoes = [];
      this.events = [];
      this.cnaes = [];
    },

    handlerUpload() {
      for (var field in this.data) {
        const event = "upload-" + field;

        if (field.search("arquivo") != -1 && this.events.indexOf(event) == -1) {
          this.$events.on(event, (eventData) => {
            if (this.events.indexOf(event) != -1) {
            }
          });

          this.events.push(event);
        }
      }
    },

    handleValidation() {
      var retorno = true;

      for (let i = 0; i < this.itens.length; i++) {
        const item = this.itens[i];

        if (item && item.rules) {
          var field = item.field,
            input = this.data[field];

          for (let j = 0; j < item.rules.length; j++) {
            const element = item.rules[j];

            switch (element) {
              case "required":
                if (input == null || input == "") {
                  this.error[field] = ["Campo obrigatório"];
                  retorno = false;
                }
                break;
            }
          }
        }
      }

      return retorno;
    },

    handlerSave() {
      this.config.click.save();
    },

    handleValueSelect(item, val) {
      if (!val) return val;

      if (item.option && item.option.value) {
        switch (item.option.value) {
          case "object":
            return val;
            break;

          case "id":
            return parseInt(val[item.option.value]);
            break;

          default:
            return val[item.option.value];
            break;
        }
      }

      return val.id;
    },

    handleLabelSelect(item, val) {
      if (!val) return val;

      if (item.option && item.option.label) {
        switch (item.option.label) {
          case "fdt":
            return val.pcmso + " (" + val.descricao + ")";
            break;

          case "ghe":
            return val.ghe + " (" + val.descricao + ")";
            break;

          case "modelo":
            return val.id + " (" + val.nome + ")";
            break;

          case "revisao":
            var parent = "";

            if (val.parent) {
              parent = val.parent.rev + " (" + val.parent.descricao + ") / ";
            }

            return (val.empresa ? val.empresa.nome + " :: " : "") + (val.fdt ? val.fdt.pcmso + " (" + val.fdt.descricao + ") :: " : "") + parent + val.rev + " (" + val.descricao + ")";

            break;

          case "funcionario":
            return val.nome + " (" + val.cpf + ")";
            break;

          case "empresa":
            return val.nome + " (" + val.cnpj + ")";
            break;

          case "financeiro.conta":
            return "AG: " + val.agencia + " CC: " + val.conta;
            break;

          case "equipamento_medicao":
            return val.nome + " / " + val.marca + " / " + val.modelo + " / " + val.serie;
            break;

          case "tabela.preco":
            return (val.empresa ? val.empresa.nome : "") + " / " + (val.fdt ? val.fdt.pcmso + " (" + val.fdt.descricao + ")" : "");
            break;

          case "esocial":
            return val.codigo;
            break;

          case "fator_risco":
          case "tabela_dinamica":
            return val.nome;
            break;

          default:
            return val[item.option.label];
            break;
        }
      }

      return val.nome;
    },

    handleTitleSelect(item, val) {
      if (!val) return val;

      if (item.option && item.option.title) {
        switch (item.option.title) {
          case "fdt":
            return val.pcmso + " (" + val.descricao + ")";
            break;

          case "ghe":
            return val.ghe + " (" + val.descricao + ")";
            break;

          case "modelo":
            return val.id + " (" + val.nome + ")";
            break;

          case "revisao":
            return (val.empresa ? val.empresa.nome + " :: " : "") + (val.fdt ? val.fdt.pcmso + " (" + val.fdt.descricao + ") :: " : "") + val.rev + " (" + val.descricao + ")";
            break;

          case "funcionario":
            return val.nome + " (" + val.cpf + ")";
            break;

          case "ltcat_orcamento":
            return val.codigo;
            break;

          case "empresa":
            return val.nome + " (" + val.cnpj + ")";
            break;

          case "equipamento_medicao":
            return val.nome + " / " + val.marca + " / " + val.modelo + " / " + val.serie;
            break;

          case "financeiro.conta":
            return "AG: " + val.agencia + " CC: " + val.conta;
            break;

          case "tabela.preco":
            return (val.empresa ? val.empresa.nome : "") + " / " + (val.fdt ? val.fdt.pcmso + " (" + val.fdt.descricao + ")" : "");
            break;

          default:
            return val[item.option.title];
            break;
        }
      }

      return val.nome;
    },

    handleLabelSelectHtml(item, val) {
      var width = this.window.width,
        limit = (width * 0.98) / 10;

      limit = 80;

      if (!val) return val;

      if (item.option && item.option.label) {
        switch (item.option.label) {
          case "fdt":
            return val.pcmso + " (" + val.descricao + ")";
            break;

          case "ghe":
            return val.ghe + " (" + val.descricao + ")";
            break;

          case "modelo":
            return val.id + " (" + val.nome + ")";
            break;

          case "revisao":
            return '<span style="' + (val.style ? val.style : "") + '">' + (!val.parent ? "<b>" + val.rev + " (" + val.descricao + (val.data ? " em " + this.toDate(val.data, true) : "") + ")" + "</b>" : val.rev + " (" + val.descricao + (val.data ? " em " + this.toDate(val.data, true) : "") + ")") + "</span>";
            break;

          case "funcionario":
            return "<b>" + val.nome + "</b>" + (val.empresa ? ' (<span style="font-size:9pt">' + val.empresa.nome + "</span>)" : "") + (val.cpf ? '<br><span style="font-size:9pt">' + val.cpf + "</span>" : "");
            break;

          case "ltcat_orcamento":
            return "<b>" + val.codigo + " (" + this.toDate(val.updated_at) + ")" + "</b>" + (val.descricao ? '<br><span style="font-size:9pt">' + val.descricao + "</span>" : "");
            break;

          case "financeiro.conta":
            return "<br>AG:</b> " + val.agencia + " <b>CC:</b> " + val.conta;
            break;

          case "tabela.preco":
            return "<b>" + (val.empresa ? val.empresa.nome + "</b>" : "") + '<br><span style="font-size:9pt">' + (val.fdt ? val.fdt.pcmso + " (" + val.fdt.descricao + ")</span>" : "");
            break;

          case "consulta":
            return "<b>CÓD: " + val.id_con + " (" + this.toDate(val.dt_cad, true) + ")</b>" + (val.empresa ? '<br><span style="font-size:9pt">' + val.empresa.nome + "</span>" : "") + (val.funcionario ? '<br><span style="font-size:9pt">' + val.funcionario.nome + "</span>" : "");
            break;

          case "empresa":
            return "<b>" + val.nome + "</b>" + (val.cnpj ? '<br><span style="font-size:9pt">' + val.cnpj + "</span>" : "");
            break;

          case "esocial":
            return "<b>" + this.textLimit(val.nome, limit) + "</b>" + (val.codigo ? '<br><span style="font-size:9pt">' + val.codigo + "</span>" : "");
            break;

          case "fator_risco":
            return (
              "<b>" + this.textLimit(val.nome, limit) + "</b>" 
              + (val.cod_esocial ? '<br><span style="font-size:9pt">' + val.cod_esocial + "</span>" : "") 
              + (val.cod_metodologia && val.cod_metodologia != "***" ? (!val.cod_esocial ? "<br>" : "") 
              + '<span style="font-size:9pt"> (' + val.cod_metodologia + ")</span>" : "")
            );
            break;

          case "tabela_dinamica":
            return '<span style="width:40px;margin-bottom:1px;margin-rigth:5px;float:left;background:' + val.cor + '">&nbsp;</span>' + val.nome;
            break;

          case "equipamento_medicao":
            return "<b>" + val.nome + "</b>" + (val.marca ? '<br><span style="font-size:9pt">' + val.marca + " / " + val.modelo + " / " + val.serie + "</span>" : "");
            break;

          default:
            return val[item.option.label];
            break;
        }
      }

      return val.nome;
    },

    handlerDisableYesterdayDate(date) {
      var hoje = this.toDate(null, true, "YYYY-MM-DD");
      date = this.toDate(date, true, "YYYY-MM-DD");

      if (this.maxDaysTomorrow) {
        let diff = this.diffDays(date);
        if (diff > this.maxDaysTomorrow) {
          return true;
        }
      }

      return date < hoje;
    },

    handlerDisableTomorrowDate(date) {
      var hoje = this.toDate(null, true, "YYYY-MM-DD");
      date = this.toDate(date, true, "YYYY-MM-DD");

      if (this.maxDaysTomorrow) {
        let diff = this.addDate(this.maxDaysTomorrow, date, "d");
        if (diff > this.maxDaysTomorrow) {
          return false;
        }
      }

      return date > hoje;
    },

    handleTimeOptions() {
      return {
        start: "00:00",
        step: "00:15",
        end: "24:00",
      };
    },

    handleDateOptions(item) {
      var options = null;

      this.maxDaysTomorrow = item.maxDaysTomorrow;

      if (item.yesterdayDisabledDate) {
        options = {
          disabledDate: this.handlerDisableYesterdayDate,
        };
      } else if (this.config.options && this.config.options[item.field] && this.config.options[item.field].disabledDate) {
        options = {
          disabledDate: this.config.options[item.field].disabledDate,
        };
      }

      if (item.tomorrowDisabledDate) {
        options = {
          disabledDate: this.handlerDisableTomorrowDate,
        };
      }

      return options;
    },

    handleRules(rules) {
      if (!rules || rules.length == 0) return [];

      var arr = [];

      for (var i = 0; i < rules.length; i++) {
        if (this.rules[rules[i]]) arr.push(this.rules[rules[i]]);
      }

      return arr;
    },

    handlePrefixIcon(item) {
      switch (item.mask) {
        case "money":
          return "fas fa-dollar-sign";
          break;

        case "cpf":
        case "cnpj":
        case "documento":
          return "fas fa-credit-card";
          break;

        case "telefone":
          return "fas fa-phone";
          break;

        case "celular":
          return "fas fa-mobile-alt";
          break;
      }
    },

    handleParametros() {
      var exclude = this.config.tipo_exclude ? this.config.tipo_exclude : [];

      this.post("tipo/parent", { codigo: this.config.tipo, exclude: exclude }).then((result) => {
        result = result[0];

        this.tipos = {};

        if (result.status == 200) {
          for (var i = 0; i < this.config.tipo.length; i++) {
            this.tipos[this.config.tipo[i]] = result.data[this.config.tipo[i]];
          }
        }
      });
    },

    handleCnae: function (search) {
      this.loadingCnae = true;
      this.cnaes = [];

      if (typeof search == "object" && search) {
        search = search["cnae"];
      }

      this.get("common/cnae", { search: search }).then((result) => {
        result = result[0];

        this.loadingCnae = false;

        if (result.status == 200) {
          this.cnaes = result.data.data;
        }
      });
    },

    handleEstado() {
      this.loadingEstado = true;

      this.get("common/estado", null, true).then((result) => {
        result = result[0];

        this.loadingEstado = false;
        this.estados = [];

        if (result.status == 200) {
          this.estados = result.data;

          if (this.data.id_estado) this.handleCidade(this.data.id_cidade ? this.data.id_cidade : "");
        }
      });
    },

    handleCidade(search) {
      if (!this.data || !this.data.id_estado) return;

      this.cidades = [];
      this.loadingCidade = true;

      this.get("common/cidade/" + this.data.id_estado, { search: search, take: 100 }, true).then((result) => {
        result = result[0];

        this.loadingCidade = false;

        if (result.status == 200) {
          this.cidades = result.data;
        }
      });
    },

    handleEndereco() {
      var cep = this.onlyNumber(this.data.cep);

      if (!cep) return;

      this.get("common/cep/" + cep, null, true).then((result) => {
        result = result[0];

        if (result.status == 200) {
          this.data.end = result.data.endereco.logradouro ? result.data.endereco.logradouro : this.data.end;

          this.data.bairro = result.data.endereco.bairro ? result.data.endereco.bairro : this.data.endereco_bairro;

          this.data.comp = result.data.endereco.complemento ? result.data.endereco.complemento : this.data.endereco_complemento;

          if (result.data.cidade) {
            this.data.id_cidade = result.data.cidade.id_cidade;
            this.cidades = [result.data.cidade];
          }

          if (result.data.estado) {
            this.data.id_estado = result.data.estado.uf;
          }
        }
      });
    },
  },
};
</script>

<style lang="scss">
.form-footer button {
  margin-right: 5px;
}
.item-group {
  color: #26a69a;
  text-transform: uppercase;
  font-weight: bold;
  border-bottom: solid 1px #ccc;
  margin-bottom: 5px;
  margin-top: 5px;
}
.el-form-item__content {
  /*line-height: inherit !important;*/
}

.el-select-dropdown__item {
  height: auto !important;
}
.el-cascader,
.el-color-picker,
.el-color-picker__trigger {
  width: 100% !important;
}
</style>



// WEBPACK FOOTER //
// form.vue?6caed184